import React from 'react';
import { useObserver } from 'mobx-react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import ConfirmationDialog from '../ConfirmationDialog';
import withStores from '../../stores/withStores';
import useI18n from '../../i18n/useI18n';

const PageStateDialog = props => {
  const i18n = useI18n();
  const { page, userStore, onClose } = props;

  // const [ currentPage, setCurrentPage ] = React.useState(page);
  // if (page !== currentPage) {
  //   setCurrentPage(page);
  // }

  const handleCloseDialog = () => {
    onClose();
  };

  const handleChangePageState = e => {
    page.setState(e.target.value);
  };

  const handleEditPageRoles = e => {
    const role = e.target.name;
    const checked = e.target.checked;
    if (checked) {
      page.addRole(role);
    } else {
      page.removeRole(role);
    }
  };

  React.useEffect(() => {
    const loadRoles = async () => {
      await userStore.loadAllRoles();
    };
    loadRoles();
  }, []);

  return useObserver(() => (
    <ConfirmationDialog
      open={!!page}
      onlyClose
      onClose={handleCloseDialog}
      title={i18n.t('PageStateDialog.title')}
    >
      {page && (
        <React.Fragment>
          <Box mb={2} minWidth={400}>
            <Typography variant="caption" color="textSecondary" gutterBottom>
              {page.uuid}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {page.title || i18n.t('PageStateDialog.noTitle')}
            </Typography>
          </Box>
          <Box mb={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {i18n.t('PageStateDialog.stateLabel')}
              </FormLabel>
              <RadioGroup
                aria-label="state"
                name="state"
                value={page.state}
                onChange={handleChangePageState}
              >
                <FormControlLabel
                  value="draft"
                  control={<Radio />}
                  label={i18n.t('PageStateDialog.draft')}
                />
                <FormControlLabel
                  value="public"
                  control={<Radio />}
                  label={i18n.t('PageStateDialog.public')}
                />
                <FormControlLabel
                  value="private"
                  control={<Radio />}
                  label={i18n.t('PageStateDialog.private')}
                />
              </RadioGroup>
            </FormControl>
          </Box>
          {page.state === 'private' && (
            <FormControl component="fieldset">
              <FormLabel component="legend">
                {i18n.t('PageStateDialog.rolesLabel')}
              </FormLabel>
              <FormGroup>
                {userStore.roles.map(role => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={page.viewAccess.indexOf(role.title) > -1}
                        onChange={handleEditPageRoles}
                        name={role.title}
                      />
                    }
                    label={role.title}
                  />
                ))}
              </FormGroup>
              <FormHelperText>
                {i18n.t('PageStateDialog.rolesHelperText')}
              </FormHelperText>
            </FormControl>
          )}
        </React.Fragment>
      )}
    </ConfirmationDialog>
  ));
};

export default withStores('userStore')(PageStateDialog);
